import { useQuery, useMutation } from 'react-query';
import { request } from '../utils/axios-utils';

export const fetchAllTasks = data => {
    const [_blank, searchText, pageNumber, pageSize, companyCode, taskType] = data.queryKey;
    return request({
        url: `/tasks/getAll?nameSearch=${searchText}&pageNum=${pageNumber}&pageSize=${pageSize}&companyCode=${companyCode}&taskType=${taskType}`,
        method: 'GET',
    });
};

const fetchAllTasksList = () => {
    return request({ url: '/tasks/getTaskTypes', method: 'GET' });
};

const fetchCompanyCode = () => {
    return request({
        url: '/tasks/getCompanyCodes',
        method: 'GET',
    });
};

const updateSwatchLabel = data => {
    return request({
        url: '/swatch/updateLabelName',
        method: 'patch',
        data,
    });
};

export const useUpdateSwatchLabel = (onSuccess, onError) => {
    return useMutation(updateSwatchLabel, {
        select: data => data.data,
        onError: onError ? onError : null,
        onSuccess: onSuccess,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
    });
};

export const useFetchTask = (onSuccess, select) => {
    return useQuery('tasks', fetchAllTasksList, {
        onSuccess: onSuccess ? onSuccess : null,
        select: select ? data => select(data.data) : data => data.data,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
    });
};

export const useFetchCompanyCode = onError => {
    return useQuery('companyCode', fetchCompanyCode, {
        select: data => data.data,
        onError: onError ? onError : null,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
    });
};

const useTasks = (onSuccess, select) => {
    return useQuery('tasks', fetchAllTasks, {
        onSuccess: onSuccess ? onSuccess : null,
        select: select ? data => select(data.data) : data => data.data,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
    });
};

export default useTasks;
